import colors from "../../base/colors";
import typography from "../../base/typography";
import borders from "../../base/borders";

import pxToRem from "../../functions/pxToRem";

const { inputBorderColor, text, grey, background, error } = colors;
const { size } = typography;
const { borderRadius } = borders;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: background.paper,
      fontSize: size.sm,
      borderRadius: borderRadius.sm,
      transition: "box-shadow 0.15s cubic-bezier(0.33, 0, 0.67, 1)",

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: grey[500],
        transition: "border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      },

      "&.Mui-focused": {
        boxShadow: `inset 0 -2px 0 0 ${colors.primary.main}`,
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.primary.main,
          borderWidth: "1px",
        },
        "& .MuiInputLabel-root": {
          color: colors.primary.main,
        },
      },

      "&.Mui-error": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.error.main,
        },
        "& .MuiInputLabel-root": {
          color: colors.error.main,
        },
      },

      "&.Mui-disabled": {
        backgroundColor: grey[100],
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: grey[300],
        },
      },
    },

    notchedOutline: {
      borderColor: inputBorderColor,
      transition: "border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    },

    input: {
      color: text.primary,
      padding: `${pxToRem(10)} ${pxToRem(12)}`,
      backgroundColor: "transparent",
      fontSize: size.sm,
      lineHeight: "1.4",

      "&::placeholder": {
        color: text.secondary,
        opacity: 1,
      },
    },

    inputSizeSmall: {
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      fontSize: size.xs,
      lineHeight: "1.35",
    },

    multiline: {
      color: text.primary,
      padding: 0,
    },
  },
};

export default inputOutlined;
